import React, { FC, useCallback } from "react";
import { INotification, setClass } from "@utils";
import { isMobile } from 'react-device-detect';
import { Switch } from "../switch";
import { Button } from "../button";
import { NotificationTitle } from "./NotificationTitle";
import '../../styles/components/notificationSetting.scss';

interface NotificationSettingProps {
  notification: INotification;
  isNew?: boolean;
  onChange: (notification: INotification) => void;
  onDelete?: () => void;
  onClose?: () => void;
  onSave?: () => void;
}

export const NotificationSetting: FC<NotificationSettingProps> = ({ 
  notification: n, onChange, onDelete, onClose, onSave, isNew 
}) => {
  const changeEmail = useCallback(() => onChange({
    minutes: n.minutes,
    types: {
      isMattermostSendingEnabled: n.types.isMattermostSendingEnabled,
      isEmailSendingEnabled: !n.types.isEmailSendingEnabled, 
    }
  }) , [n]);

  const changeMattermost = useCallback(() => onChange({
    minutes: n.minutes,
    types: {
      isEmailSendingEnabled: n.types.isEmailSendingEnabled, 
      isMattermostSendingEnabled: !n.types.isMattermostSendingEnabled
    }
  }), [n]);

  return (
    <div className={setClass('notification-setting', isMobile && 'mobile')}>
      <NotificationTitle 
        isNew={isNew}
        notification={n} 
        onChange={onChange} 
        onDelete={onDelete}
      />
      <div>
        <div className="switch-field">
          <Switch 
            checked={n.types.isEmailSendingEnabled} 
            onChange={changeEmail} 
          />
          <p className={setClass('switch-label', n.types.isEmailSendingEnabled && 'active')}>Email</p>
        </div>

        <div className="switch-field">
          <Switch 
            checked={n.types.isMattermostSendingEnabled} 
            onChange={changeMattermost} 
          />
          <p className={setClass('switch-label', n.types.isMattermostSendingEnabled && 'active')}>Mattermost</p>
        </div>
      </div>
      
      {isNew && (
        <div className="notification-settings-buttons">
          <Button 
            title="Отмена"
            className="outlined small"
            onClick={onClose} 
          />
          <Button 
            title="Сохранить"
            className="small"
            onClick={onSave}
          />
        </div>
      )}
    </div>
  )
};
